import React from "react";
import { connect } from "react-redux";
import { Provider } from "react-redux";
import store from "../../../../stores/reduxStore";
import * as actions from "../../../../actions/actions";

import StripeUpgradeForm from "../../stripe-upgrade-form";
import DeleteCard from "./delete-card";
import SavedCardForm from "./saved-card-form";

class SettingsCardForm extends React.Component {
    state = {};

    constructor(props) {
        super(props);
        this.props.getCurrentUser();
        this.props.getSavedCard();
    }

    componentWillUnmount() {
        clearTimeout(this.deleteSuccessTimeout);
    }

    updateCardInfo = (stripeApi, tokenData) => {
        this.props
            .settingsBillingFormSubmit(
                stripeApi,
                tokenData,
                this.props.user.username
            )
            .then(error => {
                if (!error) {
                    this.props.getSavedCard();
                }
            });
    };

    deleteCard = () => {
        this.props.deleteCard(this.props.user.username).then(() => {
            this.setState({
                cardDeleted: "Your card information has been removed."
            });

            this.deleteSuccessTimeout = setTimeout(
                () => this.setState({ cardDeleted: null }),
                10000
            );
        });
    };

    render() {
        const canUpdate =
            (this.props.user.has_credit_card && this.props.useNewCard) ||
            (!this.props.user.has_credit_card && !this.props.useNewCard);

        return (
            <StripeUpgradeForm
                submitOverride={this.updateCardInfo}
                buttonText="Save Card Info"
                disabled={!canUpdate}
            >
                {({ form, submitButton, billingInfo, error }) => {
                    let updateBilling, deleteCard;

                    if (this.props.savedCard) {
                        if (!canUpdate) {
                            form = (
                                <SavedCardForm card={this.props.savedCard} />
                            );
                            deleteCard = <li />;
                        } else {
                            deleteCard = (
                                <DeleteCard
                                    isPro={this.props.isPro}
                                    deleteCard={this.deleteCard}
                                />
                            );
                        }
                        updateBilling = (
                            <a
                                id="update-billing"
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.addNewCard();
                                }}
                            >
                                Update Billing Information
                            </a>
                        );
                    }

                    let cardDeletedMessage;
                    if (this.state.cardDeleted) {
                        cardDeletedMessage = <p>{this.state.cardDeleted}</p>;
                    }

                    return (
                        <div>
                            <fieldset>
                                <header>
                                    <h3>Billing Information</h3>
                                    {updateBilling}
                                </header>
                                <ol className="alpha">
                                    {form}
                                    {deleteCard}
                                    {cardDeletedMessage}
                                </ol>
                                <ol>
                                    <li>
                                        <p className="form-info padded">
                                            We don’t store any credit card
                                            information on our servers.{" "}
                                            <a
                                                href="https://stripe.com/help/security"
                                                target="_blank"
                                                title="We take security seriously"
                                                tabIndex="21"
                                            >
                                                Learn more
                                            </a>
                                        </p>
                                    </li>
                                </ol>
                            </fieldset>

                            <fieldset className="clearfix">
                                <header>
                                    <h3>Optional Billing Information</h3>
                                </header>
                                <ol>
                                    <li>{billingInfo}</li>
                                </ol>
                            </fieldset>
                            <div className="button-container">
                                {submitButton}
                                {error}
                            </div>
                        </div>
                    );
                }}
            </StripeUpgradeForm>
        );
    }
}

function mapStateToProps(state) {
    let { stripe, user } = state;
    let { processing, savedCard, useNewCard } = stripe;
    const isPro =
        user && user.permissions && user.permissions.market == "premium";

    return {
        user,
        processing,
        savedCard,
        useNewCard,
        isPro
    };
}

const mapDispatchToProps = {
    getCurrentUser: actions.getCurrentUser,
    getSavedCard: actions.stripeGetSavedCard,
    addNewCard: actions.stripeUseNewCard,
    deleteCard: actions.deleteCard,
    settingsBillingFormSubmit: actions.settingsBillingFormSubmit
};

const WrappedForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingsCardForm);

export {
    WrappedForm,
    SettingsCardForm as UnwrappedForm,
    mapStateToProps,
    mapDispatchToProps
};

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

class PrepaidBalanceDisplay extends React.Component {
    render() {
        let { prepaidBalance } = this.props;
        if (!prepaidBalance) {
            return null;
        }

        return (
            <div>
                <header>
                    <h3>Prepaid Remaining Balance</h3>
                </header>
                <div style={{ marginBottom: 26 }}>
                    {formatter.format(prepaidBalance / 100)}
                </div>
            </div>
        );
    }
}

const prepaidMapStateToProps = state => {
    let { download } = state;
    let { prepaidBalance } = download;
    return {
        prepaidBalance
    };
};

PrepaidBalanceDisplay = connect(
    prepaidMapStateToProps,
    {}
)(PrepaidBalanceDisplay);

export default props => (
    <Provider store={store}>
        <div>
            <PrepaidBalanceDisplay />
            <WrappedForm {...props} />
        </div>
    </Provider>
);
